<modal-container
  #modalStock
  [headerIconClass]="'far-building'"
  [headerTitle]="'product.stock'"
  [isLargeModal]="true"
  [isLoading]="isLoading"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="false"
  [isModalInModal]="true"
>
  <ng-container class="modal-button-show">
    <div
      *ngIf="!(isLoading && (!sellItems || (sellItems && !sellItems.length)))"
      (click)="showChildModal()"
      (keyup)="showChildModal()"
      tabindex="-1"
    >
      <div
        class="stock-container"
        *ngIf="!(isLoading && (!sellItems || (sellItems && !sellItems.length)))"
        (click)="showChildModal()"
        (keyup)="showChildModal()"
        tabindex="-1"
      >
        <div>
          <a [ngClass]="isSomeOfItemsExpired ? 'red' : isQuantityUnderMinimum ? 'yellow' : ''" class="link">
            {{ total + ' ' + ('piece' | translate) }}
          </a>
        </div>
      </div>
    </div>
    <div
      class="spinner-border text-primary spinner-border-sm"
      role="status"
      *ngIf="isLoading && (!sellItems || (sellItems && !sellItems.length))"
    >
      <span class="sr-only">{{ 'modal-stock-overview.loading' | translate }}</span>
    </div>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="card">
      <div class="table-responsive">
        <table class="table mb-0">
          <tbody>
            <tr class="line-height-1-5">
              <td class="border-0 no-hover p-0">
                <div class="flex-gap-10 align-items-center">
                  <product-image [product]="product"></product-image>
                  <div class="d-flex flex-column align-items-start">
                    <a class="link-bold" [routerLink]="['/product', product]">{{ product.name }}</a>
                    <div class="product-details flex-gap-5">
                      <div *ngIf="product.code">{{ 'product.code' | translate }}: {{ product.code }}</div>
                      <div *ngIf="product.ean">{{ 'product.ean' | translate }}: {{ product.ean }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="container pl-0 pr-0">
      <div class="row">
        <div class="col-4">
          <div class="h-100px card-smaller card">
            <div class="d-flex justify-content-between line-height-1-5">
              <div class="d-flex flex-column align-items-start">
                <div class="available-number">
                  {{ (total || 0).toFixed(2) }}
                </div>
                <div class="available-amount">
                  {{ 'totalInStock' | translate }}
                </div>
              </div>
              <div>
                <div class="circle-blue">
                  <span class="circle-blue-icon"><i class="far fa-warehouse-alt"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="sellItems && sellItems.length > 0">
      <div>
        <div>
          <h2 class="mb-0 text-nowrap align-self-center card-title" *ngFor="let sellItem of sellItems | slice: 0 : 1">
            {{ 'depot' | translate }}
            {{ sellItem.productDepots[0].supplier ? sellItem.productDepots[0].supplier.name : '' }}
          </h2>
        </div>

        <div class="availability-icons">
          <div class="flex-gap-5 align-items-center" *ngFor="let sellItem of sellItems | slice: 0 : 1">
            <div>
              <i class="far fa-warehouse-alt"></i>
            </div>
            <div>
              {{ sellItem.quantityStock.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="text-left pl-0 pt-0">
                <div class="flex-direction-column-gap-20">
                  <div>
                    {{ 'supplier' | translate }}
                  </div>
                </div>
              </th>
              <th>{{ 'product.batch' | translate }}</th>
              <th>{{ 'product.expirationDate' | translate }}</th>
              <th>{{ 'position' | translate }}</th>
              <th class="text-center pt-0">
                <div class="flex-direction-column-gap-20">
                  <div>
                    {{ 'stock' | translate }}
                  </div>
                </div>
              </th>
              <th class="pr-0 text-right">{{ 'purchasePrice' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sellItem of sellItems" class="line-height-1-5">
              <td class="pl-1 no-hover text-left">
                {{ sellItem.productDepots[0].supplier ? sellItem.productDepots[0].supplier.name : '' }}
              </td>
              <td class="no-hover">{{ sellItem.batch }}</td>
              <td class="no-hover">{{ sellItem.expirationDate | fmtDate: 'dd.MM.yyyy' }}</td>
              <td class="no-hover">{{ sellItem.productDepots[0].position }}</td>
              <td class="text-center no-hover">
                <span class="quantityStock badge badge-pill">{{ sellItem.quantityStock.toFixed(2) }}</span>
              </td>
              <td class="text-right pr-1 no-hover">
                {{ sellItem.productDepots[0].purchasePrice | formatPrice: product.purchaseCurrency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="stock && stock.length">
      <div *ngFor="let pDepot of stock">
        <div class="card" *ngIf="pDepot.items && pDepot.items.length > 0">
          <div class="table-responsive" *ngIf="pDepot.items && pDepot.items.length > 0">
            <div style="display: flex; justify-content: space-between">
              <div style="align-self: center">
                <h2
                  class="mb-0 text-nowrap align-self-center card-title"
                  *ngIf="pDepot.items && pDepot.items.length > 0"
                >
                  {{ 'depot' | translate }} {{ pDepot.depot ? pDepot.depot.name : pDepot.depot.name }}
                </h2>
              </div>

              <div class="availability-icons">
                <div class="flex-gap-5 align-items-center">
                  <div>
                    <i class="far fa-warehouse-alt"></i>
                  </div>
                  <div>
                    {{ pDepot.sumAll }}
                  </div>
                </div>
              </div>
            </div>

            <table class="table">
              <thead>
                <tr>
                  <th class="text-left pl-0 pt-0">
                    <div class="flex-direction-column-gap-20">
                      <div>
                        {{ 'supplier' | translate }}
                      </div>
                    </div>
                  </th>
                  <th>{{ 'product.batch' | translate }}</th>
                  <th>{{ 'product.expirationDate' | translate }}</th>
                  <th>{{ 'position' | translate }}</th>
                  <th class="text-center pt-0">
                    <div class="flex-direction-column-gap-20">
                      <div>
                        {{ 'stock' | translate }}
                      </div>
                    </div>
                  </th>
                  <th class="pr-0 text-nowrap text-right">{{ 'purchasePrice' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let depot of pDepot.items" class="line-height-1-5">
                  <td class="pl-1 no-hover text-left">
                    {{ depot.supplier ? depot.supplier.name : '' }}
                  </td>
                  <td class="no-hover">
                    {{ depot.batch }}
                  </td>
                  <td class="no-hover">
                    {{ depot.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                  </td>
                  <td class="no-hover">
                    {{ depot.position }}
                  </td>
                  <td class="text-center no-hover text-nowrap">
                    {{ depot.quantityStock.toFixed(2) }}
                  </td>
                  <td class="text-right text-nowrap no-hover pr-1">
                    {{ depot.purchasePrice | formatPrice: depot.currency || purchaseCurrencyFromCompany }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</modal-container>
